import React, { useContext, useEffect, useState } from 'react'
import { TfiCup } from "react-icons/tfi";
import './App.css'
import { Navigate, NavLink, useNavigate, useParams } from 'react-router-dom';
import { FaSpinner } from "react-icons/fa";
import { Howl } from "howler";
import { toast, ToastContainer } from 'react-toastify';
import { ProfileContext, ProfileProvider } from './ProfileContext';
import { Api_Url } from './APIUrl';
import { FiAlertCircle } from "react-icons/fi";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';




const LudoKing = () => { 

      const [loadingIds, setLoadingIds] = useState([]);

      const [amount, setAmount] = useState("");
      const [Rupee, setRupee] = useState();
      const [openBettle, setopenBettle] = useState([]);
      const [Running, setRunning] = useState([]);
      const [total, setTotal] = useState(null);
      const [showCard, setShowCard] = useState(false);
      const [isFinding, setIsFinding] = useState(true);
      const [dummyUser, setDummyUser] = useState(null);
      const [id, setId] = useState();
      const [data, setdata] = useState([]);
      const [entry_fee, setentry_fee] = useState();
      const [challenge_from, setchallenge_from] = useState();
      const [challengeId, setchallengeId] = useState();
      const [createrName, setcreaterName] = useState();
      const [OpponentName, setOpponentName] = useState();

       
  const [BetId, setBetId] = useState('');
      const [show, setShow] = useState(false);

      // const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

   
    
      
    
      const playSound = () => {
        const sound = new Howl({
          src: ["https://example.com/tada.mp3"], // Replace with a real sound URL
          volume: 0.5,
        });
        sound.play();
      };

      const navigate = useNavigate()
      const {  setWalletBalance } = useContext(ProfileContext);

      const OpenBettle =()=>{
        try { 

          const myHeaders = new Headers();
           myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch(`${Api_Url}api/open-battles`, requestOptions)
  .then((response) => response.json())
  .then((result) =>{
    if(result.success == true){
      setopenBettle(result?.data.battles)
    }else if (result.message === "Token has expired.") {
      // Token has expired, navigate to the login page
      localStorage.removeItem("token");  // Optionally remove the expired token
      window.location.href = "/";  // Redirect to login page
    }
  })
  .catch((error) => console.error(error));

        } catch (error) {
          
        }
      }


      const Runningbettle =()=>{
        try { 
          const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch(`${Api_Url}api/running-battles`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    if(result.success == true){
      setRunning(result?.data?.battles);
      setcreaterName(result.data.creator_name)
      setOpponentName(result.data.opponent_name)
    }else if (result.message === "Token has expired.") {
      // Token has expired, navigate to the login page
      localStorage.removeItem("token");  // Optionally remove the expired token
      window.location.href = "/";  // Redirect to login page
    }
  })
  .catch((error) => console.error(error));
        } catch (error) {
          
        }
      }

  const [loading, setLoading] = useState(false)

  // const createBettle = () => {
  //   setLoading(true);
  //   try {
  //     const myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  //     myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
  
  //     const raw = JSON.stringify({
  //       entry_fee: Rupee,
  //     });
  
  //     const requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };
  
  //     fetch(`${Api_Url}api/battle-create`, requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         if (result.success === true) {
  //           setModalContent(result.message); 
  //           setModalVisible(true); 
  //           OpenBettle();
  //           Runningbettle(); 

  //           setTimeout(() => {
  //             fetchProfile();
  //           }, 10000);
  //         }else if (result.message === "Token has expired.") { 
  //           localStorage.removeItem("token");   
  //           window.location.href = "/";   
  //         } else {
  //           let errorMessage = result.error;
  //           if (errorMessage && typeof errorMessage === "object") {
  //             errorMessage = Object.values(errorMessage).flat().join(", ");
  //           }
  //           setModalContent(errorMessage); 
  //           setModalVisible(true);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         setModalContent(error?.message);
  //         setModalVisible(true);
  //       });
  //   } catch (error) {
  //     console.error(error);
  //     setModalContent(error?.message);
  //     setModalVisible(true);
  //   }
  // };
  

  const createBettle = () => {
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
  
      const raw = JSON.stringify({
        entry_fee: Rupee,
      });
  
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
  
      fetch(`${Api_Url}api/battle-create`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === true) {
            setModalContent(result.message);  
            setModalVisible(true);
            OpenBettle();
            Runningbettle();
  
            setTimeout(() => {
              fetchProfile();
            }, 10000);
          } else if (result.message === "Token has expired.") { 
            localStorage.removeItem("token");  
            window.location.href = "/";  
          }
           else if (result.message === "You can set a maximum of 2 battles in waiting.") { 
            setModalContent(result?.message);
            setModalVisible(true);
          }
           else if (result.message === "Insufficient balance to create a battle.") { 
            setModalContent(result?.message);
            setModalVisible(true);
          }
            else { 
          
            let errorMessage = result.error;
            if (errorMessage && typeof errorMessage === "object") {
              errorMessage = Object.values(errorMessage).flat().join(", ");
            }
            setModalContent(errorMessage );
            setModalVisible(true);
            
          }
        })
        .catch((error) => {
          console.error(error);
          setModalContent(error?.message);
          setModalVisible(true);
        });
    } catch (error) {
      console.error(error);
      setModalContent(error?.message);
      setModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  
  const handleClose = () => setModalVisible(false);
  
  const [selectedBattleId, setSelectedBattleId] = useState(null);


  const joinBattle = (id) => {
    setLoadingIds((prev) => [...prev, id]);

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

      const raw = JSON.stringify({
        battle_id: id, 
      });
     
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${Api_Url}api/join-battle`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === true) {
            setentry_fee(result?.entry_fee)
             setchallenge_from(result?.challenge_from)
             setchallengeId(result?.id)

             toast(result?.message) 
            setLoadingIds((prev) => prev.filter((loadingId) => loadingId !== id));
            OpenBettle();
             Runningbettle(); 
 


             setTimeout(() => {
              navigate("/room",);
             }, 1500); 
          }else if (result.message === "Token has expired.") {
            // Token has expired, navigate to the login page
            localStorage.removeItem("token");  // Optionally remove the expired token
            window.location.href = "/";  // Redirect to login page
          }
          else { 
            toast(result?.message); 
            if (result.message === "Token has expired.") { 
              localStorage.removeItem("token");
              navigate("/");
              alert("Your session has expired. Please log in again.");
            } else { 
              
            }
          }
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error("Error joining battle:", error);
    }
  };




  const RejectBet = (id) =>{ 
    try {
      const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

const raw = JSON.stringify({
  "battle_id": id,
  "action": "reject"
}); 
 

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(`${Api_Url}api/reject-battle`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
   
    if(result.success == true){
      toast(result.message)
      OpenBettle();
      Runningbettle();
    }else {
            setBetId(' ')
      toast(result?.message)
      if (result.message === "Token has expired.") { 
        localStorage.removeItem("token");
        navigate("/");
        alert("Your session has expired. Please log in again.");
      } else { 
        alert(result.message || "An error occurred while fetching the profile.");
      }
          
          }
  })
  .catch((error) => console.error(error));
    } catch (error) {
      toast(error?.message)
    }
  }
      useEffect(()=>{
        OpenBettle();
        Runningbettle();

        const intervalId = setInterval(() => {
          OpenBettle();
          Runningbettle();
        }, 10000);  
     
        return () => clearInterval(intervalId);
      },[])
 




      const fetchProfile = async () => {
        try {
          const myHeaders = new Headers();
          myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
    
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
    
          const response = await fetch(`${Api_Url}api/profile`, requestOptions);
          const result = await response.json();
    
          if (result.success) {
            setdata(result?.data.user); 
          }else if (result.message === "Token has expired.") {
            // Token has expired, navigate to the login page
            localStorage.removeItem("token");  // Optionally remove the expired token
            window.location.href = "/";  // Redirect to login page
          }else{
             
          }
        } catch (error) {
          console.error("Error fetching profile:", error);
        }
      };
    


      const Navigate= useNavigate()
        useEffect(() => { 
          if(!localStorage.getItem('token')){  
            Navigate("/") 
          }
        }, [])
  return (
    <div>

      <ToastContainer/>

      <>
      {/* <Button variant="primary" onClick={handleShow}>
         Launch demo modal
       </Button> */}

       <Modal show={modalVisible} onHide={handleClose} centered>
  <Modal.Header className="border-0" style={{ backgroundColor: "#02011df0" }}>
  </Modal.Header>
  <Modal.Body className="border-0" style={{ backgroundColor: "#02011df0" }}>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <FiAlertCircle className="text-white" style={{ fontSize: "55px" }} />
    </div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <p className="text-white text-center mt-4">{modalContent}</p>
    </div>
    <div className="mt-3" style={{ display: "flex", justifyContent: "center" }}>
      <button className="btn btn-primary text-white" onClick={handleClose}>Ok</button>
    </div>
  </Modal.Body>
</Modal>

     </>

        <div className='container-fluid   px-2 mt-5'>
            <div className='row'>
                <div className='col-lg-12 mt-3 '>
            <marquee className="py-2"  style={{backgroundColor:'#de3545'}}> <h6 className='text-center text-white mb-0' > 
                
              🎲Brothers ludo🎲 में आपका स्वागत करता है 🙏 हेल्पलाइन नंबर 👉   ( केवल WhatsApp call & message)👈 🙏withdrawal मात्र 2 मिनट में मिलेगा🙏
                 </h6></marquee> 

              <div className="battle-container">
      <h2>CREATE A BATTLE!</h2>

      <div>
      {/* Input Field */}
      <div className="input-container">
        <input
          type="text"
          placeholder="Amount"
          value={Rupee}
          onChange={(e)=>{setRupee(e.target.value)}}
        />
        <button className="set-button" onClick={()=>{createBettle(); setTimeout(() => {
          setRupee("");
        }, 1000)}}>
          Set
        </button>

        
      </div>


      {total !== null && showCard && (
        <div className="card mb-3">
          <div
            className="card-header bg-light"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p>CHALLENGE FROM</p>
            <button className="px-3 btn btn-danger">DELETE</button>
          </div>
          <div className="card-body"  style={{  display: "flex",  alignItems: "center",justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <p className="text-sm text-gray-500">ENTRY FEE</p>
                <p className="text-lg text-green-500 font-bold flex items-center">
                  <span>💵</span> {amount}
                </p>
              </div>
              <div className="ms-5">
                <p className="text-sm text-gray-500">PRIZE</p>
                <p className="text-lg text-green-500 font-bold flex items-center">
                  <span>💵</span> {total.toFixed(2)}
                </p>
              </div>
            </div>

            {/* Finding or User Display */}
            <div>
              {isFinding ? (
                <FaSpinner className="spinner" />
              ) : (
                dummyUser && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={dummyUser.avatar}
                      alt="User"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        marginRight: "10px",
                      }}
                    />
                    <h6>{dummyUser.name}</h6>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      )}
    </div>
 


    <div style={{display:'flex', justifyContent:'space-between'}}>
         <h5 style={{fontWeight:'600', fontSize:'18px'}}>Open Battle</h5>

       <NavLink to="/rule">  <button className="rules-button"> RULES <span className="info-icon">ℹ️</span>
      </button> </NavLink>
    </div>

    
    {openBettle && openBettle.length > 0 ? (
  openBettle.map((res) => {
    // const isSelected = selectedBattleId === res.id;

    return (
      <div
        key={res.id}
        className="card mb-4"
        style={{ boxShadow: "0 .5rem 1rem rgba(0,0,0,.15)" }}
      >
        <div
          className="battle-header px-2"
          style={{ borderBottom: "0.5px solid #00000020" }}
        >
          <p className="mb-0 p-2" style={{ fontSize: "14px" }}>
            CHALLENGE FROM{" "}
            <span style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>
              {res?.challenge_from}
            </span>
          </p>
        </div>
        <div className="card-body pt-0">
          <div className="row">
            <div className="col-7">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <p className="mb-0 mb-1">Entry Fee</p>
                  <h6 className="pt-1">
                    <span>💵</span> {res.entry_fee}
                  </h6>
                </div>
                <div>
                  <p className="mb-0 mb-1 text-center">Prize</p>
                  <h6 className="mb-0 pt-1">
                    <span>💵</span> {res.prize}
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-5 "> 
              <div style={{ display: "flex", justifyContent: "end" }}>
                {res.status  === "Waiting" && res.is_self_created === true  ? (  
                  <div className="loader ">
                     <div>
                      <button className='btn btn-danger'  onClick={() => { 
                        RejectBet(res?.id);   
                      }}>Delete</button>
                    </div> 
                    <div className='d-flex justify-center ms-4 mt-0'>
                    <div class="spinner-border text-success fs-6 " role="status"  style={{height:'25px', width:'25px'}}></div><br></br>
                    </div>
                      <span className='mt-2'>Finding User</span>
                    </div> 
                   

                ) : res.status === "started" ? (  <>
                    <button className="btn btn-success me-2 w-75 p-0"  onClick={() => {
                      setSelectedBattleId(res.id); 
                      navigate('/room', ); 
                    }}  >Accept   </button>

                    <button
                      className="btn btn-danger w-75 p-0"
                      onClick={() => { 
                        RejectBet(res?.id);  
                       
                      }}
                    >
                      Reject    
                    </button>
                  </>
                ) : (
                  <button
                    className="btn btn-secondary"
                    style={{ boxShadow: "none" }} 
                    onClick={() => {
                      joinBattle(res.id, {
                        BatId: challengeId,
                        prizeplay: entry_fee,
                        creatorNameplay: challenge_from ?? "TahxSwad",
                        opponent:OpponentName,
                        creater: createrName,
                        
                      });alert(createrName)
                    }}
                    >
                    Play   
                  </button>
                )}
              </div>

              
            </div>
          </div>
        </div>
      </div>
    );
  })
) : (
  <p>No battles available</p>
)}

 
  
      
      <div className="battle-section"> 
        <div className="battle-header">
          <span>Running Battle</span>
        </div>

        <div className="battle-list">
          {Running?.map((battle, index) => ( 
            <div key={index} className="battle-card ">
              <div className="battle-info pb-2 px-0"  style={{borderBottom:'1px solid #ddd'}}>
                <span style={{fontSize:'13px'}}>  PLAYING FOR  <strong style={{fontSize:'14px'}}>{battle?.entry_fee} 💵</strong>   </span>
                <span style={{fontSize:'13px'}}> Prize  <strong style={{fontSize:'14px'}}> {battle.prize} 💵</strong>  </span>
                {
  battle?.is_self_created === true? <> 
  
  <button className="btn btn-success me-2  p-0 px-2 ms-2" 
   onClick={() => {
    navigate('/room', {
      state: { 
        battleId: battle.id, 
        battle: battle 
      }
    });
  }}  >   Accept     </button>
                    <button
                      className="btn btn-danger  p-0 px-2"
                      onClick={() => { 
                        // setBetId(battle?.id)  
                        RejectBet(battle?.id) ;
                        
                        // alert(battle?.id)
                      }}
                    >  Reject   </button>
  </>:<></>
}
              </div>
              <div className="players">
                
                <div className="player">
                  
                  <div className="player-avatar">👤</div>
                  <span>{battle?.creator_name}</span>
                </div>
                <div className="vs-icon">VS</div>
                <div className="player">
                  <div className="player-avatar">👤</div>
                  <span>{battle?.opponent_name}</span>
                </div> 
              </div>
            </div>
          ))}
        </div>


      </div>
    </div>
                 
                 </div>
                </div>
            </div> 
        </div>
     
  )
}

export default LudoKing


























//  <>
//       <Button variant="primary" onClick={handleShow}>
//         Launch demo modal
//       </Button>

//       <Modal show={show} onHide={handleClose}  centered   >
//         <Modal.Header className='border-0' style={{backgroundColor:'#02011df0'}}> 
//         </Modal.Header>
//         <Modal.Body className='border-0' style={{backgroundColor:'#02011df0'}}>
//                <div  style={{display:'flex', justifyContent:'center'}}> 
//         <FiAlertCircle  className='text-white  '  style={{fontSize:'55px'}}/>
//         </div>
//                <div  style={{display:'flex', justifyContent:'center'}}> 
                
//                 <h5 className='mt-4 text-white'>You Can Set Maximum 2 Bettle</h5>
//         </div>

//         <div className='mt-4' style={{display:'flex', justifyContent:'center'}}>
//         <button className='btn text-white' onClick={handleClose}>Ok</button>
//         </div>

//         </Modal.Body>
       
//       </Modal>
//     </>

// {
//   openBettle && openBettle.length > 0 ? (
//     openBettle?.map((res, item) => {
//       return (
//         <div
//           key={item}
//           className="card mb-4"
//           style={{ boxShadow: "0 .5rem 1rem rgba(0,0,0,.15)" }}
//         > 
//           <div className="battle-header px-0" style={{ borderBottom: "0.5px solid #00000020" }} >
//             <p className="mb-0 p-2">
//               CHALLENGE FROM{" "}
//               <span style={{ fontWeight: "400", color: "red" }}>{res?.challenge_from}</span>
//             </p>
//           </div>
//           <div className="card-body pt-0">
//             <div className="row">
//               <div className="col-8">
//                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                   <div>
//                     <p className="mb-0 mb-1">Entry Fee</p>
//                     <h6 className="pt-1">
//                       <span>💵</span> {res.entry_fee}
//                     </h6>
//                   </div>
//                   <div>
//                     <p className="mb-0 mb-1 text-center">Prize</p>
//                     <h6 className="mb-0 pt-1">
//                       <span>💵</span> {res.prize}
//                     </h6>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-4 mt-2">
//                 <div style={{ display: "flex", justifyContent: "end" }}>
//                   <button className="btn btn-secondary"
//                     style={{ boxShadow: "none" }}  onClick={() => {
//                       joinBattle();
//                       setId(res.id); 
//                   }}
//                   >   Play
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     })
//   ) : (
//     <div className="no-data">
//       <h6 className='text-center pt-3'>No Open Battle data </h6> 


//       <div
          
//           className="card mb-4"
//           style={{ boxShadow: "0 .5rem 1rem rgba(0,0,0,.15)" }}
//         >
//           <div
//             className="battle-header px-0"
//             style={{ borderBottom: "0.5px solid #00000020" }}
//           >
//             <p className="mb-0 p-2">
//               CHALLENGE FROM{" "}
//               <span style={{ fontWeight: "400", color: "red" }}>rahul</span>
//             </p>
//           </div>
//           <div className="card-body pt-0">
//             <div className="row">
//               <div className="col-5">
//                 <div style={{ display: "flex", justifyContent: "space-between" }}>
//                   <div>
//                     <p className="mb-0 mb-1">Entry Fee</p>
//                     <h6 className="pt-1">
//                       <span>💵</span> 200
//                     </h6>
//                   </div>
//                   <div>
//                     <p className="mb-0 mb-1 text-center">Prize</p>
//                     <h6 className="mb-0 pt-1">
//                       <span>💵</span> 400
//                     </h6>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-5 mt-2">
//                 <div style={{ display: "flex", justifyContent: "end" }}>
//                   <button
//                     className="btn btn-secondary"
//                     style={{ boxShadow: "none" }}
//                   >
//                     Play
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>  
//     </div>
//   )
// }















// <div style={{ display: "flex", justifyContent: "end" }}>
// {isSelected ? (
//   <>
//     <button
//       className="btn btn-success me-2 w-75 p-0"
//       onClick={() => {
//         joinBattle(res.id , {
//           state: {
//             creatorName: res.challenge_from,
//             opponentName: res?.opponent_name,  
//             entryFee: res.entry_fee,
//             prize: res.prize,
//             battleId: res.id, 
//           },
//         }); // Join battle when Start is clicked
//         setTimeout(() => {
          
//         }, 1000);
//       }}
//     >
//       Start
//     </button>
//     <button
//       className="btn btn-danger w-75 p-0"
//       onClick={() => {
//         setSelectedBattleId(null); // Reset selected battle
//         RejectBet(); // Reject the battle
//       }}
//     >
//       Reject
//     </button>
//   </>
// ) : (
//   <button
//     className="btn btn-secondary"
//     style={{ boxShadow: "none" }}
//     onClick={() => {
//       setSelectedBattleId(res.id); // Set the battle as selected
//     }}
//   >
//     Play
//   </button>



// )}
// </div>